import { render, staticRenderFns } from "./ChooseAlternativeBeneficiary.vue?vue&type=template&id=342f9ed4&scoped=true"
import script from "./ChooseAlternativeBeneficiary.vue?vue&type=script&lang=js"
export * from "./ChooseAlternativeBeneficiary.vue?vue&type=script&lang=js"
import style0 from "./ChooseAlternativeBeneficiary.vue?vue&type=style&index=0&id=342f9ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f9ed4",
  null
  
)

export default component.exports